import React, { useState, useEffect } from "react";
import Sidebar from "./Sidebar";
import { LOGO_SRC } from "./navConfig";
import "./layout.css";

const AppLayout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 992);
  const [collapsed, setCollapsed] = useState(() => {
    const saved = localStorage.getItem("sidebarCollapsed");
    return saved === "true";
  });

  useEffect(() => {
    localStorage.setItem("sidebarCollapsed", collapsed);
  }, [collapsed]);

  useEffect(() => {
    const handleResize = () => {
      const desktop = window.innerWidth >= 992;
      setIsDesktop(desktop);
      if (desktop) setSidebarOpen(false);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const showTopbar = !isDesktop;
  const sidebarVisible = isDesktop || sidebarOpen;
  const effectiveCollapsed = isDesktop && collapsed;

  return (
    <div className="app-layout">
      {showTopbar && (
        <header className="layout-topbar">
          <button
            type="button"
            className="layout-topbar__menu"
            onClick={() => setSidebarOpen((o) => !o)}
            aria-label={sidebarOpen ? "Close menu" : "Open menu"}
            aria-expanded={sidebarOpen}
          >
            <i className="fas fa-bars" />
          </button>
          <img
            alt="niroggyan"
            className="layout-topbar__logo"
            src={LOGO_SRC}
          />
        </header>
      )}

      <Sidebar
        open={sidebarVisible}
        onClose={isDesktop ? undefined : () => setSidebarOpen(false)}
        collapsed={effectiveCollapsed}
        toggleCollapsed={() => setCollapsed(!collapsed)}
        isDesktop={isDesktop}
      />

      <main
        className={`main-content ${effectiveCollapsed ? "main-content--collapsed" : ""}`}
      >
        {children}
      </main>
    </div>
  );
};

export default AppLayout;
